<template>
  <div>
    <div class="footer-1">
      <div class="container flex">
      
        <div class="connect">
          <div class="title">联系我们</div>
          <div class="txt">电话：028-87339103   028-61861026   87360033 （培训报名咨询电话）</div>
          <div class="txt">Mail：cdswhg@126.com</div>
          <div class="txt">地址：四川省成都市草堂路17号</div>
        </div>
        <div class="link">
          <div class="title">友链</div>
          <a href="http://www.cdsszwhg.com/index.html">www.cdsszwhg.com</a>
          
        </div>
      
      </div>
      
    </div>
    <div class="footer-2 flex">

      <div class="txt">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">蜀ICP备17003512号-1</a>
        /
        <span>dachuan.cdlians.tech 达川区文化馆 版权所有，未经授权禁止复制或镜像</span>
        /
        <span>技术支持：炼石科技</span>
      </div>
    </div>
  </div>
    
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
  .footer-1 {
    min-height: 200px;
    background-color: #1A2E43;
    padding: 120px 0 120px;
    box-sizing: border-box;
    .connect {
      width: 800px;
      margin-right: 150px;
      box-sizing: border-box;
      .title {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        line-height: 40px;
        letter-spacing: 2px;
        margin-bottom: 10px;
        position: relative;
        &::after {
          content: " ";
          width: 100px;
          background-color: #fff;
          height: 2px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      .txt {
        padding-top: 20px;
        padding-top: 20px;
        color: #fff;
        font-size: 16px;
      }
    }
    .link {
      width: 400px;
      .title {
        color: #ffff;
        font-size: 18px;
        
        line-height: 40px;
        letter-spacing: 2px;
        margin-bottom: 10px;
        position: relative;
        &::after {
          content: " ";
          width: 100px;
          background-color: #fff;
          height: 2px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      a {
        display: inline-block;
        text-decoration: none;
        color: white;
        margin-top: 10px;
      }
    } 
  }
  .footer-2 {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    .icon {
      font-size: 0;
    }
    .txt {
      font-size: 18px;
      a {
        color: #1A2E43;
        text-decoration: none;
        cursor: pointer;
      }
      span {
        display: inline-block;
        // margin: 0 10px;
      }
    }
  }
</style>